import { AiModal } from '@aigc/components';
import { useOverlayRef } from '@aigc/overlay-hook';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { App, Form, Input } from 'antd';
import { useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { FormControl } from '../../../components/form-control';
import { updateAigcAssetMutation } from '../api';
import type { AssetDto } from '../model';

interface AssetEditModalProps {
  row: AssetDto;
}

export function AssetEditModal({ row }: AssetEditModalProps) {
  const overlay_ref = useOverlayRef();
  const { message } = App.useApp();
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      name: row.name,
    },
    resolver: yupResolver(
      object({
        name: string().required().max(64),
      }),
    ),
  });

  const update = useMutation(updateAigcAssetMutation(row.id));

  return (
    <AiModal
      title="编辑人物"
      confirmLoading={update.isPending}
      onCancel={() => overlay_ref.close()}
      onOk={form.handleSubmit(async (values) => {
        if (update.isPending) {
          return;
        }
        await update.mutateAsync(values);
        message.success('修改成功');
        overlay_ref.close();
      })}
    >
      <Form layout="vertical">
        <FormControl
          name="name"
          label="人物名称"
          control={form.control}
          required
          render={({ field }) => <Input {...field} maxLength={64} />}
        />
      </Form>
    </AiModal>
  );
}
